$(function(){
    $(document).on("click", ".wb_interact", function(){
        var field = $(this).data("field");
        var value = $(this).data("value");
        if(field == "type"){
            clearWidget();
            if(value == "team"){
                $("#wb_team_picker").fadeIn();
                $("#wb_league_picker").hide();
                $(this).addClass("wb_item_active");
                $(".wb_league").removeClass("wb_item_active");
                localStorage.setItem("wb_type", "team");
            } else {
                $("#wb_league_picker").fadeIn();
                $("#wb_team_picker").hide();
                $(this).addClass("wb_item_active");
                $(".wb_team").removeClass("wb_item_active");
                localStorage.setItem("wb_type", "league");
            }
            $("#wb_step_2").fadeIn();
        }

        if(field == "theme"){
            $(this).addClass("wb_theme_active");
            if(value == "light"){
                $(".wb_dark").removeClass("wb_theme_active");
                localStorage.setItem("wb_theme", "light");
            } else {
                $(".wb_light").removeClass("wb_theme_active");
                localStorage.setItem("wb_theme", "dark");
            }
        }

        renderPreviewWidget();
    });

    $(".wb_item_search").keyup(function(){
        var type = $(this).data("item-type");

        if($(this).val().length > 2){
            var search_string = $(this).val();
            $.post(
                ajaxUrl+"/ajax/getTargetByString.php",
                {
                    search : search_string,
                    type   : type
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        if(type == "team") {
                            $("#team_suggestions").html(result.data);
                            $("#team_suggestions").fadeIn();
                            $("#league_suggestions").hide();
                        } else {
                            $("#league_suggestions").html(result.data);
                            $("#league_suggestions").fadeIn();
                            $("#team_suggestions").hide();
                        }
                    }
                }
            );
        } else {
            $("#team_suggestions").html("").fadeOut();
            $("#league_suggestions").html("").fadeOut();
            return false;
        }
    });

    $(document).on("click", ".wb_add_target", function(){
        if($(this).data("type") == "team"){
            $("#team_suggestions").html($(this).parent()[0].outerHTML);
        } else {
            $("#league_suggestions").html($(this).parent()[0].outerHTML);
        }

        $(".wb_item_search").val("");
        localStorage.setItem("wb_target_id", $(this).data("target-id"));
        $("#wb_step_3").fadeIn();
        renderPreviewWidget();
        return false;
    });

    $(".wb_size").keyup(function(){
        if($(this).val().length > 2) {
            var field = $(this).data("field");

            if (field == "wb_width") {
                if ($(this).val() < 250) {
                    $(this).val(250);
                }
                if ($(this).val() > 900) {
                    $(this).val(900);
                }
            } else {
                if ($(this).val() < 250) {
                    $(this).val(250);
                }
                if ($(this).val() > 900) {
                    $(this).val(900);
                }
            }

            localStorage.setItem(field, $(this).val());
            renderPreviewWidget();
        }
    });

    $(document).on("click", "#wb_create", function(){
        var type = localStorage.getItem("wb_type");
        var targetId = localStorage.getItem("wb_target_id");
        var theme = localStorage.getItem("wb_theme");
        var width = localStorage.getItem("wb_width");
        var height = localStorage.getItem("wb_height");
        var domain = $("#wb_domain").val();
        var contact = $("#wb_contact").val();
        var ip = $("#wb_ip").val();

        if(domain == "" && contact == ""){
            return false;
        }
        if(validateEmail(contact) == false){
            $("#wb_contact").addClass("wb_error");
            return false;
        } else {
            $("#wb_contact").removeClass("wb_error");
        }

        $.post(
            ajaxUrl+"/ajax/saveWidget.php",
            {
                wb_type : type,
                wb_target_id : targetId,
                wb_theme : theme,
                wb_width : width,
                wb_height : height,
                wb_domain : domain,
                wb_contact : contact,
                wb_ip : ip
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    var id = result.id;
                    var ifrm = document.createElement("iframe");
                    ifrm.setAttribute("src", "https://widget.fotboll.com/widget.php?widget_id="+id);
                    ifrm.setAttribute("frameborder",0);
                    ifrm.style.width = width+"px";
                    ifrm.style.height = height+"px";
                    ifrm.style.border = 0;
                    ifrm.style.maxWidth = "100%";
                    $("#wb_embed_code").val(ifrm.outerHTML);
                    $("#wb_step_6").fadeIn();
                }
            }
        );
        return false;
    });

    $("#wb_embed_code").focus(function() {
        var $this = $(this);
        $this.select();

        $this.mouseup(function() {
            $this.unbind("mouseup");
            return false;
        });
    });
});

function renderPreviewWidget(){
    var type = localStorage.getItem("wb_type");
    var targetId = localStorage.getItem("wb_target_id");
    var theme = localStorage.getItem("wb_theme");
    var width = localStorage.getItem("wb_width");
    if(width == ""){
        width = $("#wb_width").val();
        localStorage.setItem("wb_width", width);
    }
    var height = localStorage.getItem("wb_height");
    if(height == ""){
        width = $("#wb_height").val();
        localStorage.setItem("wb_height", height);
    }

    if(type != ""){
        if(targetId != ""){
            if(theme != ""){
                if(isNumber(width) && width > 249){
                    if(isNumber(height) && height > 149){
                        // https://widget.fotboll.com/widget-preview.php?type=team&targetId=277&theme=light&height=400&width=400&heading=Forza%Leipzig
                        var queryStr = "?type="+type+"&targetId="+targetId+"&theme="+theme+"&width="+width+"&height="+height;
                        var ifrm = document.createElement("iframe");
                        ifrm.setAttribute("src", "https://widget.fotboll.com/widget-preview.php"+queryStr);
                        ifrm.setAttribute("frameborder",0);
                        ifrm.style.width = width+"px";
                        ifrm.style.height = height+"px";
                        ifrm.style.maxWidth = "100%";
                        $("#wb_iframe_wrapper").html(ifrm);
                        $("#wb_step_4").fadeIn();
                        $("#wb_step_5").fadeIn();
                    } else {
                        console.log("Missing height");
                    }
                } else {
                    console.log("Missing width");
                }
            } else {
                console.log("Missing theme");
            }

        } else {
            console.log("Missing TargetId");
        }
    } else {
        console.log("Missing type");
    }
}

function clearWidget(){
    localStorage.setItem("wb_type", "");
    localStorage.setItem("wb_target_id", "");
    localStorage.setItem("wb_theme", "");
    localStorage.setItem("wb_width", "");
    localStorage.setItem("wb_height", "");
    $(".wb_size").val("");
    $("#wb_step_3").fadeOut();
    $("#wb_step_4").fadeOut();
    $("#wb_step_5").fadeOut();
}
function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function validateEmail(email){
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}